function equalizeCoffeeCards() {
  const blocks = [
    '.coffee-card__title',
    '.coffee-card__subtitle',
    '.coffee-card__rating',
    '.coffee-card__aromas-wrap',
    '.coffee-card__bars',
    '.coffee-card__brew',
  ];

  blocks.forEach(selector => {
    document.querySelectorAll(selector).forEach(el => {
      el.style.minHeight = '';
    });
  });

  blocks.forEach(selector => {
    const elements = document.querySelectorAll(selector);
    let maxHeight = 0;
    elements.forEach(el => {
      maxHeight = Math.max(maxHeight, el.offsetHeight);
    });
    elements.forEach(el => {
      el.style.minHeight = maxHeight + 'px';
    });
  });
}

document.addEventListener('DOMContentLoaded', equalizeCoffeeCards);
window.addEventListener('resize', equalizeCoffeeCards);